/**
 * useHasBlog — lightweight check for "does this project have a blog?"
 *
 * Used by the unified Share dropdown to decide whether to show the
 * Video / Blog tab strip. Polls only on mount; the BlogStudioView's
 * own polling keeps the cache warm if the user is on the Blog tab.
 */

import { useEffect, useState } from 'react';
import { blogAPI } from '@/services/blogAPI';

export function useHasBlog(conversationId: string): { exists: boolean; loaded: boolean } {
  const [exists, setExists] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoaded(false);
    blogAPI
      .get(conversationId)
      .then((r) => {
        if (cancelled) return;
        // "exists" means a saved doc OR an in-flight generation.
        setExists(!!r?.exists || !!r?.generating);
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setExists(false);
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [conversationId]);

  return { exists, loaded };
}
